import React, { Component, push } from "react";
//import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Accordion,
  AccordionPanel,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Spinner,
  //Notification,
  //Notification,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Console,
  // Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  StatusGood,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Close,
  MoreVertical,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
//import { showToast } from "../common/UtilityHelper";
//import Canceldemo from "./Canceldemo";
import auth from "./Security/Auth";
import {
  //callApiGetJson,
  callApiPostJson,
  // APIServerURL,
  // logAccess,
  // debugLog,
} from "./GlobalSettings";
//import StaticTypeDemoDisplay from "./StaticTypeDemoDisplay";
//import { Event } from "@material-ui/icons";
//import UpdateExtensionMessage from "./UpdateExtensionMessage";
//import ExtendDemoQuestion from "./ExtendDemoQuestion";
//import StaticClickDemoFrame from "./StaticClickDemoFrame";
//import TMEAddSeatsOverlay from "./TMEAddSeatsOverlay";
//import Alert from "@material-ui/lab/Alert";
//import { Alert } from "@material-ui/core";
//import { isThisSecond } from "date-fns";
//import TmeCRSeatlst from "./TmeCRSeatlst";
//import DemoLaunchInfo from "./DemoLaunchInfo";

class EvtAprAddInfoPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bdispCancel: false,
      UserInfo: auth.getUserInfo(),
      UserActions: auth.getUserActions(),
      disableDAprSubmit: false,
      showDAprLoader: false,
      evtData: this.props.EvtData,
      Url: null,
      Uid: null,
      Pwd: null,
      RealM: null,
    };
    this.onClose = this.onClose.bind(this);
    this._hanldeDeepApprovalClick = this._hanldeDeepApprovalClick.bind(this);
    this._handleUrlChange = this._handleUrlChange.bind(this);
    this._handleUIdChange = this._handleUIdChange.bind(this);
    this._handlePwdChange = this._handlePwdChange.bind(this);
    this._handleRealMChange = this._handleRealMChange.bind(this);
    //this._ShowCancel = this._ShowCancel.bind(this);
    // this._hanldeApprovalClick = this._hanldeApprovalClick.bind(this);
    // this._hanldeDenialClick = this._hanldeDenialClick.bind(this);
  }

  componentDidMount() {
    // this._loadVRNetLaunchInfo();
  }

  componentWillUnmount() {
    //clearInterval(this._evtInterval);
  }

  onClose() {
    this.props.hide();
  }
  /*  _ShowCancel() {
    this.setState({ bdispCancel: true });
  } */

  _hanldeDeepApprovalClick() {
    console.log("Handle Additional Info Type Event Approval Kicked Off");
    if (this.state.Url && this.state.Uid && this.state.Pwd) {
      var evtAprData = {
        EventId: this.state.evtData.Event_ID,
        Status: "Approved",
        IsAdditionalInfoType:
          this.props.EvtData.Env_Type === "TME-LAB" ||
          this.props.EvtData.Env_Type === "EDGELINE" ||
          this.props.EvtData.Env_Type === "STATIC-TYPE" ||
          this.props.EvtData.Env_Type === "TME_INDIVIDUAL" ||
          this.props.EvtData.Env_Type === "TME_CLASSROOM"
            ? true
            : false,
        Url: this.state.Url,
        Uid: this.state.Uid,
        Pwd: this.state.Pwd,
        Realm: this.state.RealM ? this.state.RealM : null,
      };

      var endpoint = "/Events/ApproveDenyEvent";
      let token = auth.getToken();
      var postData = evtAprData;
      console.log(
        "Event Approval with Additional Info request data for Update :",
        postData
      );
      this.setState({
        showDAprLoader: true,
        disableDAprSubmit: true,
        // disableDenSubmit: true,
      });
      //start below
      callApiPostJson(endpoint, postData, token).then((data) => {
        console.log("Approval Event result data from API:", data);
        if (data) {
          console.log("UpdateMessage: ");
          console.log(data);
          this.setState({ showDAprLoader: false });
          this.props.callback(data);
          //this.props.router.replace("/home");
        }
      });
    }
  }

  _handleUrlChange(value) {
    console.log("Url changed with value ", value);
    this.setState({ Url: value });
  }

  _handleUIdChange(value) {
    console.log("User Id changed with value ", value);
    this.setState({ Uid: value });
  }

  _handlePwdChange(value) {
    console.log("Password changed with value ", value);
    this.setState({ Pwd: value });
  }

  _handleRealMChange(value) {
    console.log("RealM changed with value ", value);
    this.setState({ RealM: value });
  }

  render() {
    //this.reLoadEventBasics();
    // var _Evt = this.props.Evt;
    var disableDAprSubmit = false;
    if (
      this.state.Url !== null &&
      this.state.Uid !== null &&
      this.state.Pwd !== null
    ) {
      disableDAprSubmit = true;
    }

    return (
      <Layer
        position="center"
        full={false}
        modal
        onClickOutside={this.onClose}
        onEsc={this.onClose}
      >
        <Heading level="1" size="xxsmall" margin="none">
          Additional Information required
        </Heading>
        <Box round="full" overflow="hidden">
          <Button icon={<Close />} onClick={this.props.hide} secondary />
        </Box>
        <Box fill="vertical" align="stretch" justify="start">
          <Main
            overflow="auto"
            background={{ image: "url('')" }}
            flex
            align="stretch"
            justify="start"
          >
            <Box
              align="stretch"
              justify="center"
              flex="grow"
              background={{ color: "background-back" }}
              direction="row"
            >
              {/* <Header
                  align="start"
                  direction="column"
                  flex={false}
                  justify="center"
                  gap="xxsmall"
                >
                  
                  <Heading margin="none">Info. for approval</Heading>
                </Header> */}

              <Box
                align="stretch"
                justify="start"
                flex="shrink"
                pad={{ horizontal: "large", vertical: "medium" }}
                gap="medium"
                basis="xlarge"
                direction="column"
              >
                <Box
                  align="stretch"
                  justify="center"
                  background={{ color: "background-front" }}
                  pad="medium"
                  gap="small"
                >
                  <Text size="medium">URL *</Text>
                  <TextInput
                    value={this.state.Url}
                    type="text"
                    plain={false}
                    // disabled={true}
                    onChange={(event) =>
                      this._handleUrlChange(event.target.value)
                    }
                    size="medium"
                  />

                  <Text>User Name *</Text>
                  <TextInput
                    value={this.state.Uid}
                    type="text"
                    plain={false}
                    // disabled={true}
                    onChange={(event) =>
                      this._handleUIdChange(event.target.value)
                    }
                    size="medium"
                  />

                  <Text>Password *</Text>
                  <TextInput
                    value={this.state.Pwd}
                    type="text"
                    plain={false}
                    // disabled={true}
                    onChange={(event) =>
                      this._handlePwdChange(event.target.value)
                    }
                    size="medium"
                  />

                  <Text>Realm</Text>
                  <TextInput
                    value={this.state.RealM}
                    type="text"
                    plain={false}
                    // disabled={isdisabled}
                    onChange={(event) =>
                      this._handleRealMChange(event.target.value)
                    }
                    size="medium"
                  />
                  <br />
                  <Button
                    label="Approve"
                    // fill={true}
                    primary={true}
                    icon={<StatusGood color="black" />}
                    onClick={this._hanldeDeepApprovalClick}
                    disabled={this.state.disableDAprSubmit}
                  />
                </Box>
              </Box>
            </Box>
          </Main>
        </Box>
      </Layer>
    );
  }
}

export default EvtAprAddInfoPopup;
